import { useEffect, useState } from "react";
import { api, brl } from "@/lib/api";

export const MOVE_TYPES = { ganho: "Ganho", resgate: "Resgate", estorno: "Estorno", expirado: "Expirado", ajuste: "Ajuste" };
export const MOVE_STATUS = { pendente: "Pendente", confirmado: "Confirmado", cancelado: "Cancelado" };
const num = (v) => Number(v || 0).toLocaleString("pt-BR", { maximumFractionDigits: 2 });
export const fmtPts = (v) => `${num(v)} pts`;
export const fmtUnits = (mode, v) => (mode === "cashback" ? brl(v) : fmtPts(v));
export const toYmd = (d) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;

export function lastDays(n) {
  const s = new Date();
  s.setDate(s.getDate() - (n - 1));
  return { start: toYmd(s), end: toYmd(new Date()) };
}

export function rewardSummary(wallet, sel, freeDel = false, fee = 0) {
  const list = (wallet?.rewards || []).filter((r) => sel.includes(r.id));
  const fd = freeDel && wallet?.free_delivery?.enabled;
  return {
    points: list.reduce((s, r) => s + r.points, 0) + (fd ? wallet.free_delivery.points : 0),
    discount: list.filter((r) => r.type === "discount").reduce((s, r) => s + r.value, 0),
    products: list.filter((r) => r.type === "product"),
    deliveryOff: fd ? fee : 0,
  };
}

export function useWallet(customerId) {
  const [w, setW] = useState(null);
  useEffect(() => {
    setW(null);
    if (customerId) api.get(`/loyalty/wallet/${customerId}`).then((r) => setW(r.data)).catch(() => setW(null));
  }, [customerId]);
  return w;
}
